var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconToggle40Off(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    fillRule: "nonzero",
    d: "M28.75,11 L12.25,11 C7.696,11 4,15.032 4,20 C4,24.968 7.696,29 12.25,29 L28.75,29 C33.304,29 37,24.968 37,20 C37,15.032 33.304,11 28.75,11 Z M11.95,25.2 C9.211,25.2 7,22.922 7,20.1 C7,17.278 9.211,15 11.95,15 C14.689,15 16.9,17.278 16.9,20.1 C16.9,22.922 14.689,25.2 11.95,25.2 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggle40Off);
export default __webpack_public_path__ + "static/media/icon_toggle_40_off.8d998fcd86c6c1344c026d315adbdb9b.svg";
export { ForwardRef as ReactComponent };